import type { CustomFlowbiteTheme } from 'flowbite-react';

export const listTheme: CustomFlowbiteTheme['list'] = {
  root: {
    base: 'space-y-1 text-titan-night-500 list-inside',
    ordered: {
      off: 'list-disc',
      on: 'list-decimal',
    },
    horizontal: 'flex flex-wrap items-center space-x-4 space-y-0',
    unstyled: 'list-none',
  },
};
